// extracted by mini-css-extract-plugin
export default {"transaction-group":"transaction-group__028x+","title":"title__kHLbJ","transactions":"transactions__G0bE+"};